// File: config.appbarUserMenu.ts
// Author: James L Seebach
// Date: 5/15/2017
// Desc: Configuration file for app bar user menu.
// Other Contributors: Joseph M Diaz

export const appBarUserMenu = {
    items: [
        { name: 'User Profile', action: 'openProfileDialog', icon: '' },
        { name: 'Log Out', action: 'logOut', icon: '' }
    ]
};